export default __webpack_public_path__ + "legal-hammer.png";